import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const textOnPath: DataBindingComponentModel = {
  panel: {
    height: 212,
    title: 'TextOnPath.DataBinding.Title',
    // TODO: add help id
    helpId: '',
  },
  componentName: 'TextOnPath_db_comp_name',
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'textOnPathRole',
      bindings: [
        {
          title: 'TextOnPath.DataBinding.Label',
          prop: 'text',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.number,
            FieldType.dateTime,
            FieldType.time,
            FieldType.url,
            FieldType.address,
            FieldType.richText,
          ],
          defaultFieldType: FieldType.text,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'gfpp_edit_text',
              label: 'TextOnPath.DataBinding.EditText',
            },
          },
        },
      },
      manageContentPanel: {
        description: 'TextOnPath.DataBinding.ManageContent',
      },
    },
  ],
  compactErrorPanel: true,
}
